<template>
  <input
    :id="name"
    :value="modelValue"
    type="text"
    :name="name"
    :class="{ invalid: hasErrors }"
    :data-test-base-text-input="name"
    @input="$emit('update:modelValue', $event.target.value)"
    @blur="$emit('blur', $event.target.value)"
  />
</template>

<script>
import { FormContextKey } from 'vee-validate';
import { inject } from 'vue';

export default {
  name: 'BaseTextInput',
  setup() {
    return { form: inject(FormContextKey, undefined) };
  },
  props: {
    name: {
      type: String,
      default() {
        return 'base-text-input';
      }
    },
    modelValue: {
      type: String,
      default() {
        return null;
      }
    },
    errors: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    hasErrors() {
      if (this.errors !== null) return this.errors[this.name] !== undefined;

      if (this.form) {
        return this.form.errors._value[this.name] !== undefined;
      }
      return false;
    }
  }
};
</script>
